export const hasPotRefunds = state => (state.potRefunds.length !== 0)

export const hasOtherAppPotRefunds = state => (state.otherAppPotRefunds.length !== 0)

export const isCurrentPotEmpty = state => state.pot ? (state.pot.current_amount === 0) : true

export const account = state => state.pot && (state.pot.paypal_account || state.pot.bank_account)

export const hasAccount = (_, getters) => !!getters.account
